import { render } from "./HomeHelp.vue?vue&type=template&id=7da12570"
import script from "./HomeHelp.vue?vue&type=script&lang=js"
export * from "./HomeHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__